(($) => {

    'use strict'

    if ($('.canaleco-wrapper').length) {

        var currentBatch = 0
        var amountOfBatch = $('.canaleco-wrapper').length

        $('.canaleco-wrapper').each(function(){
            if($(this).data('batch') == currentBatch){
                $(this).show()
            } else {
                $(this).hide()
            }
        })

        setInterval(function(){

            $('.canaleco-wrapper').each(function(){
                $(this).hide()
            })

            currentBatch += 1
            if(currentBatch >= amountOfBatch){
                currentBatch = 0
            }

            $('.canaleco-wrapper').each(function(){
                if($(this).data('batch') == currentBatch){
                    $(this).show()
                }
            })

        }, 8000)

    }

    if ($('.modal-opener').length) {
        $('.modal-opener').each(function(){
            $(this).click(function(event) {

                event.preventDefault()

                $('.modal').each(function(){
                    $(this).removeClass('open')
                })

                $('#modal-' + $(this).data('modal')).addClass('open')
                $('.modal-overlay').show()

            })
        })
    }

    $('.modal > .close').click(function(event) {

        event.preventDefault()

        $('.modal').each(function(){
            $(this).removeClass('open')
        })

        $('.modal-overlay').hide()

    })

    $('.modal-overlay').click(function(event) {

        event.preventDefault()

        $('.modal').each(function(){
            $(this).removeClass('open')
        })

        $('.modal-overlay').hide()

    })

    if ($('#proxipass_partner_map').length) {

        var map = new google.maps.Map(document.getElementById('proxipass_partner_map'), {
            zoom: 12,
            center: {
                lat: 47.087446,
                lng: 6.799092
            },
        })

        // Init the InfoWindow
        var infowindow = new google.maps.InfoWindow()

        // Init the geocoder
        var geocoder = new google.maps.Geocoder()

        // Marker list request
        var markerListPromise = $.ajax({
            url: siteGlobals.siteUrl + '/wp-json/ecopharma/v1/proxipass_partner',
            method: 'GET',
            contentType: 'application/json',
        })

        // Process data harvested from the rest api
        markerListPromise.then((result) => {

            // Init markers
            var locations = []

            // Loop on every branch office
            result.forEach((post, index) => {

                var icon = {
                    url: siteGlobals.siteUrl + '/wp-content/themes/ecopharma/assets/images/proxipass-marker-green.svg',
                    scaledSize: new google.maps.Size(50, 50),
                };

                var marker = new google.maps.Marker({
                    map: map,
                    position: {
                        lat: parseFloat(post.lat),
                        lng: parseFloat(post.lng)
                    },
                    icon: icon
                });

                google.maps.event.addListener(marker, 'click', (function(marker, index) {

                    return function() {

                        var opening_hours = '';

                        if (post.opening_hours_monday_morning != null) {
                            opening_hours += 'Lu: ' + post.opening_hours_monday_morning;
                        }

                        if (post.opening_hours_monday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_monday_evening;
                        }
                        
                        if(post.opening_hours_monday_morning != null || post.opening_hours_monday_evening != null){
                            opening_hours += '<br>';
                        }
  
                        if (post.opening_hours_tuesday_morning != null) {
                            opening_hours += 'Ma: ' + post.opening_hours_tuesday_morning;
                        }

                        if (post.opening_hours_tuesday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_tuesday_evening;
                        }
                        
                        if(post.opening_hours_tuesday_morning != null || post.opening_hours_tuesday_evening != null){
                            opening_hours += '<br>';
                        }

                        if (post.opening_hours_wednesday_morning != null) {
                            opening_hours += 'Me: ' + post.opening_hours_wednesday_morning;
                        }

                        if (post.opening_hours_wednesday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_wednesday_evening;
                        }
                        
                        if(post.opening_hours_wednesday_morning != null || post.opening_hours_wednesday_evening != null){
                            opening_hours += '<br>';
                        }

                        if (post.opening_hours_thursday_morning != null) {
                            opening_hours += 'Je: ' + post.opening_hours_thursday_morning;
                        }

                        if (post.opening_hours_thursday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_thursday_evening;
                        }
                        
                        if(post.opening_hours_thursday_morning != null || post.opening_hours_thursday_evening != null){
                            opening_hours += '<br>';
                        }

                        if (post.opening_hours_friday_morning != null) {
                            opening_hours += 'Ve: ' + post.opening_hours_friday_morning;
                        }

                        if (post.opening_hours_friday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_friday_evening;
                        }
                        
                        if(post.opening_hours_friday_morning != null || post.opening_hours_friday_evening != null){
                            opening_hours += '<br>';
                        }

                        if (post.opening_hours_saturday_morning != null) {
                            opening_hours += 'Sa: ' + post.opening_hours_saturday_morning;
                        }

                        if (post.opening_hours_saturday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_saturday_evening;
                        }
                        
                        if(post.opening_hours_saturday_morning != null || post.opening_hours_saturday_evening != null){
                            opening_hours += '<br>';
                        }

                        if (post.opening_hours_sunday_morning != null) {
                            opening_hours += 'Di: ' + post.opening_hours_sunday_morning;
                        }

                        if (post.opening_hours_sunday_evening != null) {
                            opening_hours += ' / ' + post.opening_hours_sunday_evening;
                        }
                        
                        if(post.opening_hours_sunday_morning != null || post.opening_hours_sunday_evening != null){
                            opening_hours += '<br>';
                        }

                        var content = '<div class="info-window">' +
                            '<h3 style="font-size: 18px;"><a href="' + post.url + '" target="_blank">' + post.title + '</a></h3>' +
                            '<address>' +
                            post.address + '<br>' +
                            post.zip + ' ' + post.city + '<br>' +
                            'Tél. ' + post.phone + '<br>' +
                            '</address>' + '<br>' +
                            '<p>' +
                            opening_hours
                            '</p>' +
                            '</div>';

                        infowindow.setContent(content)
                        infowindow.open(map, marker)
                    }

                })(marker, index))

            })

        })

    }

    // --------------------------------------------------

    function hide_contact(visible) {
        $('#footer-widgets .widget_text>h4').each(function() {
            var title = $(this).text()
            var reg = new RegExp('^__(.*)__$')
            if (reg.test(title)) {
                $(this).hide()
                if (title != visible) {
                    $(this).parent('.widget').hide()
                } else {
                    $(this).parent('.widget').show()
                }
            }
        })
    }

    $('#locationswitcher').change(function() {
        Cookies.set('vnv-pharmacy', $(this).find('option:selected').val().replace('__', '').slice(0,-2))
        hide_contact($(this).find('option:selected').val())
        window.dispatchEvent(new Event('resize'))
    })

    if(Cookies.get('vnv-pharmacy')){

        $("#locationswitcher option").each(function() {
            if($(this).attr('value') == '__' + Cookies.get('vnv-pharmacy') + '__'){
                $(this).attr('selected', 'selected')
            }
        })

        console.info('__' + Cookies.get('vnv-pharmacy') + '__')

        hide_contact('__' + Cookies.get('vnv-pharmacy') + '__')
    } else {
        hide_contact('__pharmacie_centrale__')
    }

    $('.image-popup').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
    })

    // --------------------------------------------------

    // $('.icon-salient-artstation').parent().html('<img width="32" src="' + siteGlobals.siteUrl + '/wp-content/themes/ecopharma/assets/images/eco-logo.svg' + '">')

    // --------------------------------------------------

})(jQuery)

document.addEventListener('DOMContentLoaded', function () {
    cookieconsent.run({"notice_banner_type":"simple","consent_type":"express","palette":"light","language":"fr","page_load_consent_levels":["strictly-necessary"],"notice_banner_reject_button_hide":false,"preferences_center_close_button_hide":false,"page_refresh_confirmation_buttons":false,"website_privacy_policy_url":"https://www.ecopharma.ch/politique-de-confidentialite/"});
});